export enum ServiceNowLanguage {
  EstonianTemp = 'hi',
  NorwegianTemp = 'nb',
  ChineseSimplifiedTemp = 'zh',
  ChineseTraditionalTemp = 'zt',
}
